import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { DataGrid } from '@material-ui/data-grid';
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert2";
import useKeyboardShortcut from "use-keyboard-shortcut";
import {
  allSites,
  columnsBank,
  columnsCash,
  columnsJournal,
  getMonthYearFromDate,
} from "../../../utils/Level/utils";
// import { NavBar } from 'app/components/NavBar';
import { CssBaseline, Paper, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Swal from "sweetalert2";
import { getVoucherIndex } from "../../../api/restApi";
import BPVoucher from "../../../components/Accounts/Voucher/BPVoucher";
import VoucherBar from "../../../components/Accounts/Voucher/voucherbar";
import VoucherHeader from "../../../components/Accounts/Voucher/voucherheader";
import { tableCellStyle } from "../../../styles";
import { saveNewVoucher } from "../../../utils/endPoints";
import { useAppSelector } from "../../../utils/hooks";

export const Voucher = () => {
  const navigate = useNavigate();
  const classes = tableCellStyle();
  const VoucherData = useAppSelector((state) => state.accountLevels.level3);
  console.log(VoucherData);
  const [showEntryForm, setShowEntryForm] = useState(false);
  const [filteredDataSource, setFilteredDataSource] = useState([]);
  const [type, setType] = useState("CPV");
  const [date, setDate] = useState(moment());
  const [voucherCurrentIndex, setVoucherCurrentIndex] = useState();
  const [creditTotal, setCreditTotal] = useState(0);
  const [debitTotal, setDebitTotal] = useState(0);
  const [difference, setDifferene] = useState(0);
  const [level3Codes, setLevel3Codes] = useState([]);
  const [single, setSingle] = useState(false);
  const [level3CodesFiltered, setLevel3CodesFiltered] = useState(
    VoucherData.filter((x) => x.type === "BANK")
  );
  const [vmode, setVMode] = useState("new");
  const [title, setTitle] = useState("New Voucher");
  const [findIndex, setFindIndex] = useState(voucherCurrentIndex);
  const [columns, setColumns] = useState(columnsBank);
  const [loading, setLoading] = useState(false);
  const [sites, setSites] = useState(allSites);
  const [site, setSite] = useState(sites[0]?.id);
  const [showSingleVoucher, setShowSingleVoucher] = useState(false);
  const [rowData, setRowData] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [voucher, setVoucher] = useState({
    voucherRecBy: "",
    voucherDepBy: "",
    invoiceBillNum: "",
    description: "",
    balance: "",
    site: "",
    type: "BRV",
    voucherItems: [],
    voucherDate: moment(),
    lockStatus: false,
  });

  useKeyboardShortcut(["F1"], () => addNewVoucher(), {
    overrideSystem: true,
  });
  function addNewVoucher() {
    setShowEntryForm(true);
    setShowSingleVoucher(false);
  }

  const handleSingleVoucher = () => {
    setShowSingleVoucher(true);
    setShowEntryForm(true);
  };

  async function typeChange(type) {
    setType(type);
    setTimeout(function () {
      setLoading(true);
    }, 500);
    // ;
    setVoucher({ ...voucher, type });
    // resetVoucher(moment(date).format('DD/MM/YYYY'), type);
    setLoading(false);
  }

  async function siteChange(nsite) {
    setSite(nsite);
    // setTimeout(function () {
    //   setLoading(true);
    // }, 500);
    // // ;
    // setLoading(false);
    setVoucher({
      ...voucher,
      site: nsite + "",
    });
  }
  async function findCallback(event, vindex) {
    let sindex = parseInt(voucherCurrentIndex) - 1;
    if (vindex) {
      sindex = vindex;
    }
    navigate("/search-voucher", {
      state: {
        vtype: type,
        vindex: sindex,
        vdate: date.format("DD/MM/YYYY"),
      },
    });
  }

  async function dateChange(dateInput) {
    setDate(moment(dateInput));
    setTimeout(function () {
      setLoading(true);
    }, 500);
    // resetVoucher(moment(dateInput).format('DD/MM/YYYY'), voucher.type);
    setLoading(false);
  }
  async function saveCallback() {
    console.log(type,voucher,creditTotal);
    voucher.type = type;
    voucher.voucherDate = moment(date).format("DD/MM/YYYY");
    if (filteredDataSource.length == 0) {
      toast.error("Voucher is empty!");
    } else if (difference == "0") {
      setTimeout(function () {
        setLoading(true);
      }, 500);

      const result = await saveNewVoucher(type, voucher, creditTotal);
      console.log("Data Saved");
      console.log(voucher);
      //resetVoucher(voucher.voucherDate, voucher.type);
      toast.success("New voucher created successfully!");
       findCallback(null, parseInt(voucherCurrentIndex));
      setLoading(false);
    } else if (difference != "0") {
      toast.error("Total Debit and Total Credit must be equall!");
    }
  }

  const cancelCallback = () => {
    setFilteredDataSource([]);
  };

  // async function resetVoucher(voucherDate, type) {
  //   const index = await voucherIndex(user.companyid, voucherDate, type);
  //   setVoucherCurrentIndex(index);
  //   if (index == 1) {
  //     setFindIndex(index);
  //   } else {
  //     setFindIndex(index - 1);
  //   }

  //   setVoucher({
  //     ...voucher,
  //     site: site,
  //     voucherRecBy: '',
  //     voucherDepBy: '',
  //     invoiceBillNum: '',
  //     description: '',
  //     balance: '',
  //     voucherItems: [],
  //     lockStatus: false,
  //   });
  //   setDifferene(0);
  //   setDebitTotal(0);
  //   setCreditTotal(0);
  //   setLoading(false);
  //   setFilteredDataSource([]);
  // }

  function addVocuherItem(data) {
    console.log(data);
    var vouch = { ...voucher };
    vouch = { ...vouch, voucherItems: filteredDataSource };
    setVoucher(vouch);
    console.log(vouch);
    // setSingle(true)
  }

  useEffect(() => {
    addVocuherItem();
  }, [filteredDataSource]);

  // function addVocuherItem2(data) {
  //   console.log(data)
  //   var vouch = { ...voucher };
  //   vouch = { ...vouch, voucherItems: [...vouch.voucherItems, data] };
  //   setVoucher(vouch);
  //   console.log(voucher)
  // }

  function getAllLevel3() {
    setLevel3Codes([]);
    setLevel3Codes(VoucherData.filter((x) => x.freeze === "NO"));
    setLevel3CodesFiltered(VoucherData.filter((x) => x.type === "BANK"));
  }

  useEffect(() => {
    if (vmode == "new") {
      setTitle("New Voucher");
    } else {
      setTitle("Find Voucher");
    }
  }, [vmode]);

  const updateVoucherData = async () => {
    let currentDate = getMonthYearFromDate(date.format("DD/MM/YYYY"));
    console.log(currentDate);

    let VoucherIndex = await getVoucherIndex(currentDate, type);
    console.log(VoucherIndex);
    setVoucherCurrentIndex(VoucherIndex?.date?.id);
  };

  useEffect(() => {
    updateVoucherData();
    getAllLevel3();
    if (sites.length <= 0) {
      swal
        .fire("Unable to create voucher. Please enter a site detail first.")
        .then(async (result) => {
          navigate("/sites-manage", { replace: true });
        });
    }
  }, []);

  useEffect(() => {
    updateVoucherData();
    if (type == "BRV" || type == "BPV") {
      setColumns(columnsBank);
      setLevel3CodesFiltered(VoucherData.filter((x) => x.type === "BANK"));
    } else if (type == "CPV" || type == "CRV") {
      setColumns(columnsCash);
      setLevel3CodesFiltered(VoucherData.filter((x) => x.type === "CASH"));
    } else {
      setLevel3CodesFiltered(
        VoucherData.filter((x) => x.type !== "BANK" && x.type !== "CASH")
      );

      setColumns(columnsJournal);
    }
  }, [type, date, level3Codes, VoucherData]);

  useEffect(() => {
    let creditTemp = 0;
    let debitTemp = 0;

    filteredDataSource.forEach(function (arrayItem) {
      var x = arrayItem.debit;
      var y = arrayItem.credit;

      if (x != "" && y == "") {
        const parsed = parseInt(x);
        debitTemp += parsed;
      }
      if (y != "" && x == "") {
        const parsed = parseInt(y);
        creditTemp += parsed;
      }
      // if(x!=="" && y!==""){
      //   const parsed1 = parseInt(x);
      //   debitTemp += parsed1;
      //   const parsed2 = parseInt(y);
      //   creditTemp += parsed2;
      // }
    });

    setCreditTotal(creditTemp);
    setDebitTotal(debitTemp);
    setDifferene(Math.abs(creditTemp - debitTemp));
  }, [filteredDataSource]);

  const processCallback = (data) => {};
  console.log(filteredDataSource);

  async function updateLevel3Data(event, params) {
    console.log(params);
    setIsEdit(true);
    setShowSingleVoucher(false);
    setRowData({
      newcode: params.row.code,
      defaultDescription: params.row.Discription,
      defaultAmount: params.row.amount,
      defaultTransactionType: params.row.transaction,
      // name: defaultName,
      // contact: defaultContact,
      // address: defaultAddress,
    });
    // setUpdateLevel3(true);
    // setName("");
    // setContact("");
    // setAddress("");
    // setCode(params.row.code);
    // setDescription(params.row.description);
    // setType(params.row.type);
    // if (params.row.name) {
    //   setName(params.row.name);
    //   setContact(params.row.contact);
    //   setAddress(params.row.address);
    // }

    // let OldValue = freeze;
    // if (params.row.freeze == "NO") {
    //   setFreeze(false);
    // } else {
    //   setFreeze(true);
    // }
    setShowEntryForm(true);
  }

  function updateLevel3DataQuery(data) {
    console.log(data);
    setIsEdit(false);
    // let codeArray = data.level3Code.split("-");
    setShowEntryForm(false);
    Swal.fire({
      title: "Are you sure to update existing code?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.value) {
        if (data.freeze) {
          data.freeze = "YES";
        } else {
          data.freeze = "NO";
        }
        setFilteredDataSource(
          filteredDataSource.map((item) => {
            if (item.code === data.code) {
              return {
                ...item,
                amount: data.amount,
                transaction: data.transaction,
                transactionType: data.transactionType,
                credit: data.credit,
                debit: data.debit,
                Discription: data.Discription,
              };
            }
            return item;
          })
        );
      }
    });
    return;
  }

  return (
    <Paper>
      <CssBaseline />
      <div>
        {/* <Loader loading={loading} /> */}

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: "1rem",
            justifyContent: "center",
            // backgroundColor: 'blue',
          }}
        >
          <ToastContainer
            position="bottom-center"
            autoClose={2000}
            hideProgressBar={true}
            closeOnClick={true}
            progress={undefined}
          />
          {showEntryForm ? (
            <BPVoucher
              okCallback={(data, addOnly) => {
                console.log(data);
                const currentId = filteredDataSource.length + 1;
                data = { ...data, id: currentId, site: site };
                {
                  !addOnly && setShowEntryForm(false);
                }
                setFilteredDataSource((filteredDataSource) => [
                  ...filteredDataSource,
                  data,
                ]);
              }}
              okCallback2={(data) => {
                const currentId = filteredDataSource.length + 2;
                data = { ...data, id: currentId, site: site };
                setFilteredDataSource((filteredDataSource) => [
                  ...filteredDataSource,
                  data,
                ]);
              }}
              cancelCallback={() => {
                setIsEdit(false);
                setShowEntryForm(false);
                setShowSingleVoucher(false);
              }}
              updateCallback={(data) => {
                updateLevel3DataQuery(data);
              }}
              // deleteCallback={(data) => {
              //   deleteLevel3Data(data);
              // }}
              level3Codes={level3Codes}
              level3CodesFiltered={level3CodesFiltered}
              vtype={type}
              visible={showEntryForm}
              singleEntryVoucher={showSingleVoucher}
              setSingle={setSingle}
              voucherRowData={rowData}
              isEdit={isEdit}
            ></BPVoucher>
          ) : (
            <></>
          )}

          <Typography variant="h5" component="h5" gutterBottom>
            {title}
          </Typography>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              width: "95%",
              height: "80vh",
              // backgroundColor: "#EDF5E1",
            }}
            className={classes.root}
          >
            <DataGrid
              headerHeight={20}
              rowHeight={25}
              style={{ width: "100%" }}
              onCellDoubleClick={(params, event) => {
                updateLevel3Data(event, params);
              }}
              rows={filteredDataSource}
              columns={columns}
              pageSize={25}
              disableColumnMenu
              components={{
                Footer: VoucherBar,
                Toolbar: VoucherHeader,
              }}
              componentsProps={{
                toolbar: {
                  typeChange,
                  siteChange,
                  dateChange,
                  type,
                  site,
                  date,
                  voucher,
                  setVoucher,
                  voucherCurrentIndex,
                  setFindIndex,
                  findIndex,
                },
                footer: {
                  saveCallback,
                  cancelCallback,
                  debitTotal,
                  findCallback,
                  creditTotal,
                  difference,
                  handleSingleVoucher,
                },
              }}
            />
          </div>
        </div>
      </div>
    </Paper>
  );
};
export default Voucher;
